/** 供应商商品列表*/
export const API_GET_BBC_PRODUCT_LIST = {
  url: 'bbc/supplier/product/data/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

export const API_GET_NEW_BBC_PRODUCT_LIST = {
  url: 'new/benefit/bbc/supplier/product/data/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**商品模糊查询列表*/
export const API_GET_BBC_PRODUCT_QUERY = {
  url: 'bbc/supplier/product/query',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**商品模糊查询列表*/
export const API_GET_NEW_BENEFIT_BBC_PRODUCT_QUERY = {
  url: 'new/benefit/bbc/supplier/product/query',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**供应商更改商品信息*/
export const API_GET_BBC_PRODUCT_UPDATE = {
  url: 'bbc/supplier/product/data/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**更改库存信息*/
export const API_GET_BBC_STOCK_CENTER_UPDATE = {
  url: 'bbc/stock/center/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**更改库存信息*/
export const API_GET_NEW_BENEFIT_BBC_STOCK_CENTER_UPDATE = {
  url: 'new/benefit/bbc/stock/center/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**订单详情*/
export const API_GET_BBC_GOODS_MANAGEMENTS = {
  url: 'bbc/order/detail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**订单列表(订单层级)*/
export const API_GET_BBC__ORDER_LIST = {
  url: 'bbc/order/orderList',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**订单列表(商品层级)*/
export const API_GET_BBC__ORDER_GOODS_LIST = {
  url: 'bbc/order/orderGoodsList',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**导出发货单*/
export const API_GET_BBC__ORDER_EXPORT_DELIVERE_EXCL = {
  url: 'bbc/order/exportDeliverExcl',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**导出订单详情*/
export const API_GET_BBC__ORDER_EXPORTORDERDETAILEXCL = {
  url: 'bbc/order/exportOrderDetailExcl',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**导入发货单*/
export const API_GET_BBC__ORDER_IMPORT_DELIVERE_EXCL = {
  url: 'bbc/order/importDeliverExcl',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**物流轨迹记录*/
export const API_GET_BBC__BASICDATA_GET_LOGISTICLIST = {
  url: 'bbc/basicData/getLogisticList',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**订单页面数据统计*/
export const API_GET_BBC__ORDER_STATISTICS = {
  url: 'bbc/order/orderStatistics',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**批量缺货操作*/
export const API_GET_BBC__ORDER_BATCHSTOCK_OUT = {
  url: 'bbc/order/batchStockout',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 商品列表*/
export const API_GET_BBC_GOODS_MANAGEMENT = {
  url: 'bbc/accept/order/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 图片上传*/
export const API_POST_BBC_IMAGE_UPLOAD = {
  url: 'bbc/image/upload',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 图片上传*/
export const API_POST_BBC_IMAGEQINIU_UPLOAD = {
  url: 'bbc/image/imgUploadQiNiu',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 生成图片*/
export const API_POST_BBC_IMAGE_GENERATE = {
  url: 'bbc/image/generate',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**查询供应商商品*/
export const API_GET_BBC_GOODS_GET = {
  url: 'bbc/supplier/product/data/get',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**查询供应商商品*/
export const API_GET_NEW_BENEFIT_BBC_GOODS_GET = {
  url: 'new/benefit/bbc/supplier/product/data/get',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**复制供应商商品*/
export const API_GET_BBC_COPY_GOODS_IMAGES = {
  url: 'bbc/supplier/product/data/product/images',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**更新供应商商品*/
export const API_POST_BBC_GOODS_UPDATE = {
  url: 'bbc/supplier/product/data/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**更新供应商商品*/
export const API_POST_NEW_BENEFITBBC_GOODS_UPDATE = {
  url: 'new/benefit/bbc/supplier/product/data/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
/**节假日限制列表获取*/
export const API_POST_BBC_SUPPLIER_HOLIDAY_LIST = {
  url: 'bbc/supplier/holiday/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**节假日限制保存*/
export const API_POST_BBC_SUPPLIER_HOLIDAY_SAVE = {
  url: 'bbc/supplier/holiday/save',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**节假日限制获取*/
export const API_POST_BBC_SUPPLIER_HOLIDAY_GET = {
  url: 'bbc/supplier/holiday/get',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**节假日限制删除*/
export const API_POST_BBC_SUPPLIER_HOLIDAY_REMOVE = {
  url: 'bbc/supplier/holiday/remove',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**配送范围模板列表*/
export const API_POST_BBC_SUPPLIER_CONFIG_LIST = {
  url: 'bbc/supplierConfig/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**保存配送范围模板*/
export const API_POST_BBC_SUPPLIER_CONFIG_SAVE = {
  url: 'bbc/supplierConfig/save',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**删除配送范围模板*/
export const API_POST_BBC_SUPPLIER_CONFIG_REMOVE = {
  url: 'bbc/supplierConfig/remove',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**获取配送范围模板详情信息*/
export const API_POST_BBC_SUPPLIER_CONFIG_GET = {
  url: 'bbc/supplierConfig/get',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**获取地址信息接口*/
export const API_POST_BBC_SUPPLIER_GETAREAPAGE = {
  url: 'bbc/basicData/getAreaPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**获取物流公司数据*/
export const API_POST_BBC_SUPPLIER_GETSHIPPER = {
  url: 'bbc/basicData/getExpress',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**供应商导入商品*/
export const API_POST_BBC_SUPPLIER_PRODUCT_IMPORT = {
  url: 'bbc/supplier/product/data/import',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**供应商导入商品*/
export const API_POST_NEW_BENEFITBBC_SUPPLIER_PRODUCT_IMPORT = {
  url: 'new/benefit/bbc/supplier/product/data/import',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**供应商配送范围模板*/
export const API_POST_BBC_SUPPLIER_ALL_LIST = {
  url: 'bbc/supplierConfig/all/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**批量修改库存*/
export const API_POST_BBC_STOCK_CENTER_IMPORT = {
  url: 'bbc/stock/center/import',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**下载模板商品信息*/
export const API_POST_BBC_GOODS_IMAGE_DOWN = {
  url: 'bbc/image/down',
  config: {
    method: 'get',
    host: 'SUPPLIER',
    fileName: '批量修改商品信息',
  },
};

/**下载模板商品信息*/
export const API_POST_NEW_BENEFIT_BBC_GOODS_IMAGE_DOWN = {
  url: 'new/benefit/bbc/image/down/down',
  config: {
    method: 'get',
    host: 'SUPPLIER',
    fileName: '批量修改商品信息',
  },
};

/**下载模板商品信息*/
export const API_POST_NEW_BENEFIT_BBC_GOODS_IMAGE_DOWN2 = {
  url: 'new/benefit/bbc/image/down/down',
  config: {
    method: 'get',
    host: 'SUPPLIER',
    fileName: '批量维护库存',
  },
};

/**下载模板库存信息*/
export const API_POST_BBC_STOCK_IMAGE_DOWN = {
  url: 'bbc/image/down',
  config: {
    method: 'get',
    host: 'SUPPLIER',
    fileName: '批量维护库存',
  },
};

/**库存提醒*/
export const API_POST_BBC_STOCK_CENTER_ALERT = {
  url: 'bbc/stock/center/alert',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**库存提醒*/
export const API_POST_NEW_BENEFIT_BBC_STOCK_CENTER_ALERT = {
  url: 'new/benefit/bbc/stock/center/alert',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**在售商品数量/资料商品数量*/
export const API_POST_BBC_PRODUCT_DATA_TOTAL = {
  url: 'bbc/supplier/product/data/total',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**首页数据*/
export const API_POST_BBC_ORDER_HOMESTATISTICS = {
  url: 'bbc/order/homeStatistics',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 不发货区域
// 查询
export const API_POST_BBC_SUPPLIERCONFIG_NOT_SEND_LIST = {
  url: 'bbc/supplierConfig/not/send/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 新增 和 编辑
export const API_POST_BBC_SUPPLIERCONFIG_SAVEORUPDATEAREA = {
  url: 'bbc/supplierConfig/saveOrUpdateArea',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 删除
export const API_POST_BBC_SUPPLIERCONFIG_SEND_REMOVE = {
  url: 'bbc/supplierConfig/not/send/remove',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 获取行政区域
export const API_POST_BBC_BASICDATA_GETALLAREAPAGE = {
  url: 'bbc/basicData/getAllAreaPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 批量变更运单号
export const API_POST_BBC_LOGISTIC_GETALLAREAPAGE = {
  url: 'bbc/order/batch/update/logistic',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 已发货商品列表
export const API_POST_BBC_ORDER_LIST_GETALLAREAPAGE = {
  url: 'bbc/order/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 确认订单
export const API_POST_BBC_ORDER_BATCH_LOGISTIC = {
  url: 'bbc/order/batch/confirm/byYHang',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 供应商商品列表*/
export const API_GET_NEW_BENEFITBBC_PRODUCT_LIST = {
  url: 'new/benefit/bbc/supplier/product/data/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**批量修改库存*/
export const API_POST_NEW_BENEFIT_BBC_STOCK_CENTER_IMPORT = {
  url: 'new/benefit/bbc/stock/center/import',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**批量修改库存*/
export const API_POST_NEW_STOCK_BENEFIT_BBC_STOCK_CENTER_IMPORT = {
  url: 'new/benefit/bbc/stock/center/batchUpdateStockByImport',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
/**变更申请 -- 列表*/
export const API_POST_NEW_UPDATE_BBC_STOCK_CENTER_QUERYPAGE = {
  url: 'new/benefit/bbc/supplierProduct/update/queryPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**合作商品价格查询 -- 列表*/
export const API_POST_NEW_BENEFIT_BBC_SUPPLIER_PRODUCT_ONECLOCKPROXYSEND_LIST = {
  url: 'new/benefit/bbc/supplier/product/oneClickProxySend/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**合作商品价格查询 -- 导出*/
export const API_POST_NEW_BENEFIT_BBC_SUPPLIER_PRODUCT_ONECLOCKPROXYSEND_EXPORT = {
  url: 'new/benefit/bbc/supplier/product/oneClickProxySend/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**变更申请 -- 列表*/
export const API_POST_NEW_UPDATE_BBC_STOCK_PRODUCTPRICE_QUERYPAGE = {
  url: 'new/benefit/bbc/supplierProduct/productPrice/queryPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**变更申请 -- 列表*/
export const API_POST_NEW_UPDATE_BBC_STOCK_CENTER_QUERYDETAIL = {
  url: 'new/benefit/bbc/supplierProduct/update/queryDetail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**更新变更商品链接接口*/
export const API_POST_NEW_BENEFITBBC_UPDATE_CHANGEPRODUCTLINK = {
  url: 'new/benefit/bbc/supplierProduct/update/changeProductLink',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**福利商品-变更图片发起接口*/
export const API_POST_NEW_BENEFITBBC_UPDATE_CHANGEPRODUCTIMG = {
  url: 'new/benefit/bbc/supplierProduct/update/changeImg',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**供应商导入商品*/
export const API_POST_NEW_BBCBENEFITBBC_SUPPLIER_PRODUCT_IMPORT = {
  url: 'new/benefit/bbc/supplier/product/data/batchUpdateLogisticsByImport',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新增厂家 */
export const ADDMANUFACTURER = {
  url: 'manufacturerConfig/addManufacturerName',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 获取厂家列表 */
export const GETMANUFACTURERLIST = {
  url: 'manufacturerConfig/pageList',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 查询商品最新厂家名称 */
export const GETLATESTFACTORYNAME = {
  url: 'manufacturerConfig/getLatestFactoryName',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
